<script setup>
import { computed, shallowRef, useTemplateRef } from 'vue'
import { add } from 'date-fns'
import { useToggle } from '@vueuse/core'
import Mod from '@provise/components/mod.vue'
import Datepicker from '@provise/components/datepicker.vue'
import wrapper from './sla.vue'
import { commons } from '@provise/lib/transformer'
import { parseISO } from 'date-fns/parseISO'

const emit = defineEmits(['extended'])
defineProps({
  complaint: Object,
  step: String,
})
const wrpr = useTemplateRef('wrpr')
const [extendOpen, extendShow] = useToggle(false)
const exdate = shallowRef(null)
const minexdate = computed(() => {
  if (!extendOpen.value) {
    return null
  }
  return add(wrpr.value.sla.date_start, { days: 1 })
})

async function extend(mbs) {
  if (!wrpr.value || !exdate.value) {
    return
  }
  let myDate = parseISO(exdate.value.toISOString())
  myDate.setHours(23)
  myDate.setMinutes(59)
  await wrpr.value.extend({ date_finish: commons.dateISO(myDate) })
  emit('extended')
  mbs.hide()
}
</script>
<template>
  <wrapper #="{ sla }" v-bind="$props" ref="wrpr">
    <div
      class="d-flex align-items-center mb-3"
      v-if="sla.started && !sla.finished"
      :class="{ 'text-danger': sla.overdue }"
    >
      Завершить выполнение блока до {{ sla.finDate }} или&nbsp;
      <a :class="{ 'text-danger': sla.overdue }" href="#" @click.prevent="extendShow()">
        продлить срок выполнения
      </a>
    </div>
  </wrapper>
  <Mod v-if="extendOpen" #="{ mbs }" @hidden="extendShow(false)" size="sm">
    <form @submit.prevent="extend(mbs)">
      <div class="sla-calendar mb-3 d-flex justify-content-center">
        <Datepicker inline v-model="exdate" :min-date="minexdate" />
      </div>
      <div class="d-flex justify-content-center gap-2">
        <button class="btn btn-primary" type="submit">
          <i class="bi bi-check-square" />
          Продлить
        </button>
        <button class="btn btn-danger" @click="mbs.hide()">
          <i class="bi bi-x-square" />
          Вернуться к обращению
        </button>
      </div>
    </form>
  </Mod>
</template>
<style lang="scss">
.sla-calendar {
  .dp__flex_display {
    justify-content: center !important;
  }
  & > .form-control {
    display: none;
  }
}
</style>
